import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'card-update-applies';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function storeDate(data) {
  return post({
    url: `${url}/dates`,
    data,
  });
}

export function storeNumber(data) {
  return post({
    url: `${url}/numbers`,
    data,
  });
}

export function storeType(data) {
  return post({
    url: `${url}/types`,
    data,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}/`,
    data,
  });
}
